import { IsNotEmpty, IsInt, IsString, MaxLength, IsOptional } from 'class-validator';
import { BugDiagnosticsDTO } from './bug-diagnostics.dto';

export class BugReportDTO {

    @IsNotEmpty()
    @IsInt()
    severity: number;

    @IsNotEmpty()
    @IsString()
    @MaxLength(3000)
    description: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    page: string;

    @IsOptional()
    diagnostics?: BugDiagnosticsDTO;

}
